import { z } from "zod";

/**
 * Zod schema for Smart Work Order Creation Dialog
 * Includes only mandatory fields for quick work order creation
 */
export const smartWoCreationSchema = z.object({
  // Work Order Mandatory Fields (from workOrderSchema.ts)
  customerIdentity: z.number({
    required_error: "Customer is required",
    invalid_type_error: "Customer must be selected",
  }),
  locationIdentity: z.number({
    required_error: "Location is required",
    invalid_type_error: "Location must be selected",
  }),
  woStatusIdentity: z.number({
    required_error: "Status is required",
    invalid_type_error: "Status must be selected",
  }),
  woPriorityIdentity: z.number({
    required_error: "Priority is required",
    invalid_type_error: "Priority must be selected",
  }),
  salesPersonIdentity: z.number({
    required_error: "Sales person is required",
    invalid_type_error: "Sales person must be selected",
  }),

  // Optional technician - can be pre-populated when opened from technician card
  technicianIdentity: z.number().optional(),

  // Work date - pre-populated when opened from technician card (for scheduling)
  workDate: z.string().optional(),

  // Segment Mandatory Fields (from WorkOrderSegment.tsx:50-63)
  segment: z.object({
    displayText: z
      .string()
      .min(1, "Segment title is required")
      .max(15, "Only 15 characters allowed"),
    serviceCodeIdentity: z.number({
      required_error: "Service code is required",
      invalid_type_error: "Service code must be selected",
    }),
  }),
});

/**
 * TypeScript type inferred from the Zod schema
 */
export type SmartWoCreationFormData = z.infer<typeof smartWoCreationSchema>;

/**
 * Default values for the form
 */
export const defaultFormValues: Partial<SmartWoCreationFormData> = {
  customerIdentity: undefined,
  locationIdentity: undefined,
  woStatusIdentity: undefined,
  woPriorityIdentity: undefined,
  salesPersonIdentity: undefined,
  technicianIdentity: undefined,
  workDate: undefined,
  segment: {
    displayText: "",
    serviceCodeIdentity: undefined,
  },
};
